import { AlertsFilter } from '../../../../../shared/types/legalProceedings/alerts';

export const initialValues: AlertsFilter = {
    ruleNumber: '',
    startCreatedAt: undefined,
    endCreatedAt: undefined,
    nameAlert: '',
    status: '',
    newPqrStatus: '',
    receptionChannel: '',
    typePQR: '',
    receivedThrough: '',
    subtypeDP: '',
    transaction: '',
    active: undefined,
};
